import {http} from "../config/Constantes";

export default class AreaService {
    constructor() {}

    getGestorByCodigoArDebitoEEmpresaGloboId(codigo, empresaGloboId) {
        return http.get("/area/" + codigo + "/" + empresaGloboId + "/gestor");
    }

    list() {
        return http.get("/area");
    }

    listByPrefixoNome(nome) {
        return http.get(`/area/prefixo/${encodeURIComponent(nome)}`);
    }


}
